import { createAction } from '@reduxjs/toolkit';

import { type Volume } from '../reducers/media';

export const mediaActions = {
  volume: {
    request: createAction('volume/request'),
    success: createAction('volume/success'),
    failure: createAction('volume/failure'),
    set: createAction<Volume>('volume/set'),
  },
  sound: {
    set: createAction<boolean>('sound/set'),
    toggle: createAction('sound/toggle'),
  },
  music: {
    set: createAction<boolean>('music/set'),
    toggle: createAction('music/toggle'),
  },
  autoplaymute: {
    set: createAction<boolean>('autoplaymute/set'),
  },
  videoStreamSound: {
    set: createAction<boolean>('videoStreamSound/set'),
    toggle: createAction('videoStreamSound/toggle'),
  },
};

export type MediaActions = typeof mediaActions;
